import script from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShoppingCart.vue?vue&type=script&setup=true&lang=ts"

import "./ShoppingCart.vue?vue&type=style&index=0&id=72e40116&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72e40116"]])

export default __exports__